// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"70a77edb","160":"576e1392","206":"eeaae7e2","276":"34768937","448":"b5d1784a","453":"8d0312e8","466":"65ec4153","486":"bc9bd86c","528":"748a5b4d","535":"52bca2f7","552":"3813765e","627":"af844d24","656":"e86b1d77","807":"9d5a083a","813":"3a01aa9c","883":"7ce372d3"}[chunkId] + ".chunk.js";
};